import {useQuery} from "@tanstack/react-query";
import {readRevenueByItem} from "../../../../../api/main/DashboardApi";

export const useReadRevenueByItem = () => {
    const {data} = useQuery({
        queryKey: ["readRevenueByItem"],
        queryFn: async () => await readRevenueByItem(),
        select: (res) => res?.data.result ?? [],
    });

    return {data};
};
